import React from "react";
import { useTranslation } from "react-i18next";
import { Edit } from "lucide-react"; // icon for rating stars
import { ProductCategory } from "../../../types/modules/productCategory.type";
import CategoryItem from "./CategoryItem";
import { PermissionGate } from "../../admin/PermissionGate";
import { PermissionsKey } from "../../../data/permissions";

interface Props {
  catgeories: ProductCategory[];
}

const CategoriesListTable: React.FC<Props> = ({ catgeories }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal capitalize">{t("id")}</th>
            <th className="p-3 font-normal capitalize">{t("name_in_english")}</th>
            <th className="p-3 font-normal capitalize">{t("name_in_arabic")}</th>
            <PermissionGate permissions={[PermissionsKey.UpdateStoreCategory]}>
              <th className="p-3 font-normal capitalize">{t("actions")}</th>
            </PermissionGate>
          </tr>
        </thead>
        <tbody className="text-sm">
          {catgeories.map((catgeory, index) => (
            <tr
              key={catgeory.id}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >
             <CategoryItem catgeory={catgeory}/>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default CategoriesListTable;